<template>
  <div>
    <b-modal
        v-model="modalActive"
        hide-footer
        id="modal-center"
        centered
        :title="$t('message.Position_level')">
      <b-form-group
          :label="$t('message.Name_uz')"
          label-for="name-input"
          invalid-feedback="Name is required"
      >
        <b-form-input
            id="name-input"
            v-model="rank_level.name_uz"
            required
        />
      </b-form-group>
      <b-form-group
          :label="$t('message.Name_ru')"
          label-for="name-input"
          invalid-feedback="Name is required"
      >
        <b-form-input
            id="name-input"
            v-model="rank_level.name_ru"
            required
        />
      </b-form-group>
      <b-form-group
          :label="$t('message.Name_en')"
          label-for="name-input"
          invalid-feedback="Name is required"
      >
        <b-form-input
            id="name-input"
            v-model="rank_level.name_en"
            required
        />
      </b-form-group>
      <b-form-group
          :label="$t('message.Name_kr')"
          label-for="name-input"
          invalid-feedback="Name is required"
      >
        <b-form-input
            id="name-input"
            v-model="rank_level.name_kz"
            required
        />
      </b-form-group>
      <div
          style="margin-top: 30px; margin-left: 150px">
        <b-button
            variant="outline-primary"
            @click="handleClick"
        >{{$t('message.Cancel')}}
        </b-button>
        <b-button
            @click="handleSubmit"
            style="margin-left: 10px"
            variant="primary"
        >{{$t('message.Add')}}
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>

import {addPositionLevel, editPositionLevel, getLevelById} from "../../../../../../../api/directories";

export default {
  name: "RankLevelModal",
  props: {
    activeModal: {
      type: Boolean
    },
    id: {
      default: null,
    }
  },
  data(){
    return{
      rank_level: {
        name_uz: '',
        name_ru: '',
        name_en: '',
        name_kz: ''
      },
    }
  },
  computed: {
    modalActive: {
      get() {
        return this.activeModal;
      },
      set(val) {
        if(!val) this.$emit('closeModal')
      }
    }
  },
  methods:{
    handleClick(){
      this.modalActive = false
    },
    fetchRankLevel(){
      getLevelById({ id : this.id }).then(response => {
        this.rank_level = response.data.data
      })
    },
    handleSubmit() {
      if (this.rank_level.name_uz
          && this.rank_level.name_ru
          && this.rank_level.name_en
          && this.rank_level.name_kz) {
        if (this.id) {
          // eslint-disable-next-line no-unused-vars
          editPositionLevel(this.rank_level).then(res => {
            this.$emit('closeModal')
          })
        } else {
          // eslint-disable-next-line no-unused-vars
          addPositionLevel(this.rank_level).then(res => {
            this.$emit('closeModal')
          })
        }
      }
    },
  },
  watch: {
    id:{
      immediate: true,
      handler(val) {
        if(val) {
          this.fetchRankLevel()
        }
      }
    }
  }
}
</script>

<style scoped>

</style>




